module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h3', [_vm._v(_vm._s(_vm.rowData.actionType) + " | "), _c('b', {
    class: 'text-' + _vm.approvalType(_vm.rowData.status)
  }, [_vm._v(_vm._s(_vm.rowData.status))]), _vm._v(" | " + _vm._s(_vm.rowData.siteName) + " - " + _vm._s(_vm.rowData.partyName))]), _vm._v(" "), _c('el-timeline', _vm._l((_vm.timeline), function(step) {
    return _c('el-timeline-item', {
      key: step.id,
      attrs: {
        "timestamp": 'Last Update: ' + _vm.formatDateTime(step.updated_at),
        "placement": "top"
      }
    }, [_c('el-card', [_c('h4', [_c('i', {
      class: step.stepIcon
    }, [_vm._v(" ")]), _vm._v(_vm._s(step.stepName))]), _vm._v(" "), (step.remarks) ? _c('html-input', {
      attrs: {
        "disabled": "",
        "no-form": ""
      },
      model: {
        value: (step.remarks),
        callback: function($$v) {
          _vm.$set(step, "remarks", $$v)
        },
        expression: "step.remarks"
      }
    }) : _vm._e(), _vm._v(" "), (step.stepNo == 1 && _vm.rowData.remarks) ? _c('div', [(_vm.rowData.remarks) ? _c('html-input', {
      attrs: {
        "disabled": "",
        "no-form": ""
      },
      model: {
        value: (_vm.rowData.remarks),
        callback: function($$v) {
          _vm.$set(_vm.rowData, "remarks", $$v)
        },
        expression: "rowData.remarks"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.hasFiles(step.stepNo, step.partyNo)) ? _c('el-row', {
      attrs: {
        "gutter": 24
      }
    }, [_c('el-table', {
      attrs: {
        "data": _vm.stepFiles(step.stepNo, step.partyNo)
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "title",
        "label": "File Type"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "File Name"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "upload_at",
        "label": "Uploaded At"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "upload_by",
        "label": "Uploaded By"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "lastDownload_at",
        "label": "Last Download At"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "lastDownload_by",
        "label": "Last Download By"
      }
    })], 1), _vm._v(" "), _c('center', [_c('small', {
      staticClass: "text-primary"
    }, [_vm._v("Total Uploads "), _c('b', [_vm._v(_vm._s(step.stepFiles))])])])], 1) : _vm._e(), _vm._v(" "), (step.step_completed || step.step_approved) ? _c('el-row', {
      attrs: {
        "gutter": 24
      }
    }, [(step.step_approved) ? _c('el-col', {
      attrs: {
        "span": step.step_completed ? 12 : 24
      }
    }, [_c('el-alert', {
      attrs: {
        "type": _vm.approvalType(step.approvedStatus),
        "show-icon": "",
        "closable": false,
        "center": "",
        "title": step.approvedStatus,
        "description": 'On ' + _vm.formatDateTime(step.step_approved_at) + (step.step_approved_by ? ' by ' + step.step_approved_by : '')
      }
    })], 1) : _vm._e(), _vm._v(" "), (step.step_completed) ? _c('el-col', {
      attrs: {
        "span": step.step_approved ? 12 : 24
      }
    }, [_c('el-alert', {
      attrs: {
        "type": "info",
        "show-icon": "",
        "closable": false,
        "center": "",
        "title": "Completed",
        "description": 'On ' + _vm.formatDateTime(step.step_completed_at) + (step.step_completed_by ? ' by ' + step.step_completed_by : '')
      }
    })], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
  }), 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pull-right",
    attrs: {
      "layout": "prev, pager, next",
      "hide-on-single-page": "",
      "total": _vm.timeline.length
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04ad0d56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/requests/RequestReportDetails.vue
// module id = 1395
// module chunks = 0